import type React from 'react';

import { Avatar } from '@mui/material';

import { useClient } from '@src/entities/clients';

import * as st from './styles.module.scss';

type Props = {
	id: number;
};

export const ConsultationClient: React.FC<Props> = ({ id }) => {
	const { client } = useClient(id);

	const getName = () => {
		if (!client) return;
		return `${client.last_name} ${client.first_name} ${client.middle_name ?? ''}`;
	};

	return (
		<div className={st.buyer}>
			<Avatar sx={{ width: 40, height: 40 }} src={client?.photo}>
				{client?.last_name?.slice(0, 1)}
			</Avatar>
			<div className={st.buyer__name}>{getName()}</div>
		</div>
	);
};
